module.exports = __webpack_public_path__ + "media/images/home/concept_title_bg-9668d7f5c8d57914c8e60058bab63787.png";